// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#error-msg {
  font-size: 12px;
  padding: 3px;
  color: red;
  display: none;
}

input:invalid ~ #error-msg {
  display: block;
}

.pincode-input-container {
  .pincode-input-text {
    padding: 0 !important;
    margin: 0 2px;
    text-align: center;
    border: 1px solid;
    background: transparent;
    width: 50px;
    height: 50px;
  }
  .pincode-input-text:focus {
    outline: none;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Input.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["#error-msg {\r\n  font-size: 12px;\r\n  padding: 3px;\r\n  color: red;\r\n  display: none;\r\n}\r\n\r\ninput:invalid ~ #error-msg {\r\n  display: block;\r\n}\r\n\r\n.pincode-input-container {\r\n  .pincode-input-text {\r\n    padding: 0 !important;\r\n    margin: 0 2px;\r\n    text-align: center;\r\n    border: 1px solid;\r\n    background: transparent;\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  .pincode-input-text:focus {\r\n    outline: none;\r\n    box-shadow: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
